import * as React from 'react';

import BusinessInfoSection from './BusinessInfoSection';
import BuySection from './BuySection';
import CarOfTheYearSection from './CarOfTheYearSection';
import CarousellSection from './CarousellSection';
import GuidesSection from './GuidesSection';
import NewsletterForm from './NewsLetterForm';
import SellSection from './SellSection';
import ServicesSection from './ServicesSection';
import SocialLinksSection from './SocialLinksSection';

function Footer({ theme = 'light' }) {
  const isDark = theme === 'dark';
  
  return (
    <div className={`md:mt-16 mt-8 text-sm ${isDark ? 'bg-black text-white' : 'bg-[#F0F1F1] text-os-black'}`}>
      <div className="max-w-[1440px] mx-auto px-4 py-8 md:px-8 xl:px-16 lg:pt-14 lg:pb-36">
        <section className="flex flex-col xl:flex-row lg:gap-x-20">
          <BusinessInfoSection theme={theme} />
          <div className="grid grid-cols-2 lg:grid-cols-2 flex-1 mt-8 xl:mt-0">
            <div className="flex flex-col md:gap-y-8 lg:grid lg:grid-cols-2">
              <div className="flex flex-col md:gap-y-2">
                <SellSection theme={theme} />
                <BuySection theme={theme} />
              </div>
              <div className="flex flex-col md:gap-y-2">
                <ServicesSection theme={theme} />
                <GuidesSection theme={theme} />
              </div>
            </div>
            <div className="flex flex-col md:gap-y-2 lg:grid lg:grid-cols-2">
              <CarOfTheYearSection theme={theme} />
              <CarousellSection theme={theme} />
            </div>
          </div>
        </section>
        <div className={`border-t ${isDark ? 'border-gray-800' : 'border-os-light-gray'} mt-16 mb-8`} />
        <section>
          <NewsletterForm theme={theme} />
        </section>
        <div className={`border-t ${isDark ? 'border-gray-800' : 'border-os-light-gray'} my-8`} />
        <section className={`${isDark ? 'text-gray-400' : 'text-content-secondary'} flex flex-col gap-y-4 lg:flex-row justify-between items-center leading-6`}>
          <div className="order-3 lg:order-1">
            © 2024 OneShift by Carousell
          </div>
          <ul className="order-1 lg:order-2 flex gap-1 mb-0">
            <li>
              <a
                className={`${isDark ? 'text-gray-400 visited:text-gray-400' : 'text-content-secondary visited:text-content-secondary'}`}
                href="/tos/"
              >
                Terms of Service
              </a>
            </li>
            <li>•</li>
            <li>
              <a
                className={`${isDark ? 'text-gray-400 visited:text-gray-400' : 'text-content-secondary visited:text-content-secondary'}`}
                href="/about-us/"
              >
                About Us
              </a>
            </li>
            <li>•</li>
            <li>
              <a
                className={`${isDark ? 'text-gray-400 visited:text-gray-400' : 'text-content-secondary visited:text-content-secondary'}`}
                href="/privacy/"
              >
                Privacy Policy
              </a>
            </li>
            <li>•</li>
            <li>
              <a
                className={`${isDark ? 'text-gray-400 visited:text-gray-400' : 'text-content-secondary visited:text-content-secondary'}`}
                href="/business-conduct/"
              >
                Business Conduct
              </a>
            </li>
          </ul>
          <SocialLinksSection theme={theme} />
        </section>
      </div>
    </div>
  );
}

export default Footer;
